import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { SupplierDeactivationAdminComponent } from './supplier-deactivation-admin.component';

const routes: Routes = [
  {
    path: '',
    component: SupplierDeactivationAdminComponent,
    data: { title: 'Supplier Deactivation Admin' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierDeactivationAdminRoutingModule {}

@NgModule({
  imports: [
    SupplierDeactivationAdminRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [SupplierDeactivationAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SupplierDeactivationAdminModule {}
